module.exports = __webpack_public_path__ + "static/media/doctor_banner.a1d2be07.jpg";